import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { InitiateSigningModel } from '../pathways-ui/models/initate-signing.model';
import { StudentConsentModel } from '../pathways-ui/models/student-consent.model';

@Injectable({
  providedIn: 'root'
})
export class SpConsentService {
  
  consentController: string = '/api/consent';

  constructor(private http: HttpClient) {}

  signSingleDocument(signingObject: InitiateSigningModel): Observable<Object> {
    return this.http
      .post<Object>(`${this.consentController}/sign`, signingObject)
      .pipe(map((data) => data));
  }

  signPathwaysDocuments(orgCode: string): Observable<Object> {
    return this.http
      .get<Object>(
        this.consentController +
          `/SignPathwaysDocs/${orgCode}`
      )
      .pipe(
        map((data) => {
          return data;
        })
      );
  }

  getEnvelopeStatus(consentId: string | number): Observable<Object> {
    return this.http
      .get<Object>(
        this.consentController + `/GetEnvelopeStatus/${consentId}`
      )
      .pipe(
        map((data) => {
          return data;
        })
      );
  }

  getStudentConsentsToSign(studentRegistrationSchoolYearId: number): Observable<StudentConsentModel[]> {
    return this.http
      .get<StudentConsentModel[]>(
        `${this.consentController}/GetStudentConsents/${studentRegistrationSchoolYearId}`
      )
      .pipe(map((data) => data));
  }

  getConsentLink(studentRegistrationSchoolYearId: number): Observable<StudentConsentModel> {
    return this.http
      .get<StudentConsentModel>(
        `${this.consentController}/GetConsentLink/${studentRegistrationSchoolYearId}`
      )
      .pipe(map((data) => data));
  }
}
